import styled from "styled-components";
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { IconClose } from "../../Assets/IconClose";
import { IconArrow } from "../../Assets/IconArrow";

const Style = styled.div`
    min-width: 440px;
    min-height: calc(80vh - 120px - 2rem);
    margin: 0;
    display: flex;
    flex-direction: column;
    background-color: #ffffff;
    &.rtl {
        direction: rtl;
    }
    &.ltr {
        direction: ltr;
    }
    .top {
        margin: 0 1.25rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #aaa;
        .title {
            font-size: 1.2rem;
            font-weight: 700;
            padding: 1.25rem 0;
        }
        .btn-container {
            cursor: pointer;
            margin: -10px;
            padding: 10px;
            position: relative;
        }
        .close-btn {
            display: block;
            width: 20px;
            height: 20px;
        }
    }
    .top-nav {
        display: none;
        gap: 0.25rem;
        min-height: 60px;
        background-color: #ffffff;
        align-items: center;
        padding: 0 1rem;
        box-shadow: 0px 4px 16px 0px #00000029;
        .close-btn {
            cursor: pointer;
            display: block;
            width: 24px;
            height: 24px;
            fill: #000000;
        }
        .title {
            font-size: 0.9rem;
            font-weight: 600;
            padding-bottom: 0.2rem;
        }
    }
    @media (max-width: 850px){
        min-width: auto;
        min-height: auto;
        position: fixed;
        inset: 0;
        /* width: 100vw; */
        /* height: 100svh; */
        flex-direction: column;
        .top {
            display: none;
        }
        .top-nav {
            display: flex;
        }
        .content {
            margin: 0.5rem 0;
            .expand {
                flex-grow: 0;
            }
        }
        .image {
            flex-grow: 0;
            min-height: 120px;
            background-color:  unset;
            svg {
                width: unset;
                fill: var(--prime-1);
            }
        }
    }
`;
export default function PopupMainPanel({
    lang="en",
    title = "",
    open = true, 
    close = () => {}, 
    save = () => {},
    children=[], 
    ...props
}){
    let paperStyle = {
        borderRadius: "var(--border-radius-32)",
    }
    if(window.innerWidth < 850){
        paperStyle = {
            borderRadius: "0",
            margin: 0,
            maxHeight: "none",
            maxWidth: "none",
        }
    }
    return(
        <Dialog
            open={open}
            // onClose={close}
            maxWidth={false}
            PaperProps={{
                sx: paperStyle
            }}

            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <Style className={((lang === "fa") ? "rtl" : "ltr")}>
                <div className="top">
                    <div className="title">
                        {title}
                    </div>
                    <div 
                        className="btn-container"
                        onClick={close}
                    >
                        <IconClose 
                            className="close-btn"
                            style={{fill: "#1E1E1E"}}
                        />
                    </div>
                </div>
                <div className="top-nav">
                    <div 
                        className="btn-container"
                        onClick={close}
                    >
                        <IconArrow 
                            className="close-btn"
                        />
                    </div>
                    <div className="title">
                        {title}
                    </div>
                </div>
                {children}
            </Style>
        </Dialog>
    )
}